import React from 'react';

export interface StatisticValueProps {
    children: React.ReactNode;
    secondary?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const StatisticValue: React.FC<StatisticValueProps> = ({
    children,
    secondary = false,
    className = '',
    style = {},
}) => {
    const valueStyles: React.CSSProperties = {
        fontSize: secondary ? '16px' : '32px',
        fontWeight: 600,
        color: secondary ? 'var(--malachite-text-dimmed)' : 'var(--malachite-text-primary)',
        lineHeight: '1.2',
        margin: 0,
        ...style,
    };

    return (
        <span className={className} style={valueStyles}>
            {children}
        </span>
    );
};

export default StatisticValue;
